/**
 * @file useWarehouseMode.ts
 * @description «Открыт экран кладовщика» для страниц склада (phase19.31,
 * шаг О4; SC30, SC44).
 *
 * Тот же признак, по которому каркас магазина включает плотность «склад»
 * (`isWarehouseMode` — роль «Складской работник» только с правами склада).
 * Страницам он нужен для поведения, а не для размеров (размеры даёт тема):
 * например, поле скана берёт фокус при открытии только у кладовщика — у
 * владельца за компьютером всплывающая клавиатура и курсор в поле не нужны.
 */

import { useAuth } from "../auth/hooks";
import { isWarehouseMode } from "../lib/shop-nav";

export function useWarehouseMode(): boolean {
  const { me } = useAuth();
  return isWarehouseMode(me?.activeContext ?? null);
}
